import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "app/providers/ProtectedRoute";
import { useUser } from "app/context/useUser";
import { SubjectParams } from "shared/utils/pagination";
const PaymentsTasksPage = lazy(() => import("./payment/payment-tasks"));
const PaymentsTaskItemsPage = lazy(() => import("./payment/payment-task-items"));
const MachineTasksPage = lazy(() => import("./machine/machine-tasks"));
const MachineTaskItemsPage = lazy(() => import("./machine/machine-task-items"));
const CarTasksPage = lazy(() => import("./car/car-tasks"));
const CarTaskItemsPage = lazy(() => import("./car/car-task-items"));
const AddressTasksPage = lazy(() => import("./address/address-tasks"));
const AddressTaskItemsPage = lazy(() => import("./address/address-task-items"));

const PermissionRoleForm = lazy(
  () => import("pages/permission/permission-role"),
);
const PermissionUserForm = lazy(
  () => import("pages/permission/permission-user"),
);
const LocationExpensesEdit = lazy(
  () => import("pages/expenses/location-expenses-edit"),
);
const LocationExpensesCreate = lazy(
  () => import("pages/expenses/location-expenses-create"),
);
const InvestorList = lazy(() => import("pages/investment/investor-list"));
const InvestObjectList = lazy(
  () => import("pages/investment/invest-object-list"),
);
const InvestObjectDetail = lazy(
  () => import("pages/investment/invest-object-detail"),
);
const InvestObjectCreate = lazy(
  () => import("pages/investment/invest-object-create"),
);
const InvestObjectEdit = lazy(
  () => import("pages/investment/invest-object-edit"),
);
const InvestGroupList = lazy(
  () => import("pages/investment/invest-group-list"),
);
const InvestGroupDetail = lazy(
  () => import("pages/investment/invest-group-detail"),
);
const InvestGroupCreate = lazy(
  () => import("pages/investment/invest-group-create"),
);
const InvestGroupEdit = lazy(
  () => import("pages/investment/invest-group-edit"),
);
const LocationExpensesDetail = lazy(
  () => import("pages/expenses/location-expenses"),
);
const LocationExpensesItemsList = lazy(
  () => import("pages/expenses/location-expenses-items-list"),
);
const LocationExpensesItemsDetail = lazy(
  () => import("pages/expenses/location-expenses-items-detail"),
);
const GroupExpensesDetail = lazy(
  () => import("pages/expenses/group-expenses-detail"),
);
const GroupExpensesOtherList = lazy(
  () => import("pages/expenses/group-expenses-other-list"),
);
const GroupExpensesOtherCreate = lazy(
  () => import("pages/expenses/group-expenses-other-create"),
);
const LocationExpensesOtherList = lazy(
  () => import("pages/expenses/location-expenses-other-list"),
);
const LocationExpensesOtherCreate = lazy(
  () => import("pages/expenses/location-expenses-other-create"),
);
const PayoutInvestorList = lazy(
  () => import("pages/payout/payout-investor-list"),
);
const PayoutInvestorCreate = lazy(
  () => import("pages/payout/payout-investor-create"),
);

const PayoutInvestorEdit = lazy(
  () => import("pages/payout/payout-investor-edit"),
);

const PayoutGroupCreate = lazy(
  () => import("pages/payout/payout-group-create"),
);

const PayoutGroupEdit = lazy(() => import("pages/payout/payout-group-edit"));

const InvestorDetail = lazy(() => import("pages/investment/investor-detail"));
const AddressList = lazy(() => import("pages/address/address-list"));
const AddressCreate = lazy(() => import("pages/address/address-create/index"));
const AddressEdit = lazy(() => import("pages/address/address-edit"));
const AddressDetail = lazy(() => import("pages/address/address-detail"));
const AddressStopList = lazy(() => import("pages/address/address-stop-list"));
const CountryList = lazy(() => import("pages/country/country-list"));
const CountryDetail = lazy(() => import("pages/country/country-detail"));
const CountryEdit = lazy(() => import("pages/country/country-edit"));
const CountryCreate = lazy(() => import("pages/country/country-create"));
const CityList = lazy(() => import("pages/city/city-list"));
const CityEdit = lazy(() => import("pages/city/city-edit"));
const CityCreate = lazy(() => import("pages/city/city-create"));
const OrderCreate = lazy(() => import("pages/order/order-create"));
const OrderEdit = lazy(() => import("pages/order/order-edit"));
const OrderList = lazy(() => import("pages/order/order-list"));
const OrderDetail = lazy(() => import("pages/order/order-detail"));
const OpenOrdersList = lazy(() => import("pages/order/open-orders-list"));
const OrderSummary = lazy(() => import("pages/order/order-summary"));
const ProductDetail = lazy(() => import("pages/product/product-detail"));
const ProductCreate = lazy(() => import("pages/product/product-create"));
const ProductSetCreate = lazy(() => import("pages/product/product-set-create"));
const ProductEdit = lazy(() => import("pages/product/product-edit"));
//const ProductList = lazy(() => import("pages/product/product-list"));
const CarDetail = lazy(() => import("pages/car/car-detail"));
const CarCreate = lazy(() => import("pages/car/car-create"));
const CarEdit = lazy(() => import("pages/car/car-edit"));
const CarList = lazy(() => import("pages/car/car-list"));
const CategoryDetail = lazy(() => import("pages/category/category-detail"));
const CategoryCreate = lazy(() => import("pages/category/category-create"));
const CategoryEdit = lazy(() => import("pages/category/category-edit"));
const CategoryList = lazy(() => import("pages/category/category-list"));
const EventDetail = lazy(() => import("pages/event/event-detail"));
const EventCreate = lazy(() => import("pages/event/event-create"));
const EventEdit = lazy(() => import("pages/event/event-edit"));
const EventList = lazy(() => import("pages/event/event-list"));
const LocationEventCreate = lazy(
  () => import("pages/location-event/event-create"),
);
const LocationEventEdit = lazy(() => import("pages/location-event/event-edit"));
const TemplateDetail = lazy(() => import("pages/template/template-detail"));
const TemplateCreate = lazy(() => import("pages/template/template-create"));
const TemplateCreatePlace = lazy(
  () => import("pages/template/template-create-place"),
);
const TemplateEdit = lazy(() => import("pages/template/template-edit"));
const TemplateList = lazy(() => import("pages/template/template-list"));
const LocationDetail = lazy(() => import("pages/location/location-detail"));
const LocationCreate = lazy(() => import("pages/location/location-create"));
const LocationEdit = lazy(() => import("pages/location/location-edit"));
const LocationList = lazy(() => import("pages/location/location-list"));
const SpaceCreate = lazy(() => import("pages/space/space-create"));
const SpaceEdit = lazy(() => import("pages/space/space-edit"));
const SpaceList = lazy(() => import("pages/space/space-list"));
const MachineDetail = lazy(() => import("pages/machine/machine-detail"));
const MachineCreate = lazy(() => import("pages/machine/machine-create"));
const MachineEdit = lazy(() => import("pages/machine/machine-edit"));
const MachineList = lazy(() => import("pages/machine/machine-list"));
const PaymentDetail = lazy(() => import("pages/payment/payment-detail"));
const PaymentCreate = lazy(() => import("pages/payment/payment-create"));
const PaymentEdit = lazy(() => import("pages/payment/payment-edit"));
const PaymentList = lazy(() => import("pages/payment/payment-list"));
const ServiceDetail = lazy(() => import("pages/service/service-detail"));
const ServiceCreate = lazy(() => import("pages/service/service-create"));
const ServiceCreateMulti = lazy(
  () => import("pages/service/service-create-multi"),
);
const ServiceEdit = lazy(() => import("pages/service/service-edit"));
const ServiceList = lazy(() => import("pages/service/service-list"));
const CalibrationEdit = lazy(() => import("pages/calibration/calibration-edit"));
const CalibrationListPage = lazy(() => import("pages/calibration/calibration-list"));


const SnackAddressDetail = lazy(
  () => import("pages/snack/snack-address-detail"),
);
const SnackAddressCreate = lazy(
  () => import("pages/snack/snack-address-create"),
);
const SnackAddressEdit = lazy(() => import("pages/snack/snack-address-edit"));
const SnackAddressList = lazy(() => import("pages/snack/snack-address-list"));
const SnackAddressFile = lazy(() => import("pages/snack/snack-address-upload"));
const SnackItemDetail = lazy(() => import("pages/snack/snack-item-detail"));
const SnackItemCreate = lazy(() => import("pages/snack/snack-item-create"));
const SnackItemEdit = lazy(() => import("pages/snack/snack-item-edit"));
const SnackItemList = lazy(() => import("pages/snack/snack-item-list"));
const ProviderDetail = lazy(() => import("pages/provider/provider-detail"));
const ProviderCreate = lazy(() => import("pages/provider/provider-create"));
const ProviderEdit = lazy(() => import("pages/provider/provider-edit"));
const ProviderList = lazy(() => import("pages/provider/provider-list"));
const Auth = lazy(() => import("pages/user/user-auth"));
const UserList = lazy(() => import("pages/user/user-list"));
const UserCreate = lazy(() => import("pages/user/user-create"));
const UserEdit = lazy(() => import("pages/user/user-edit"));
const RoleDetail = lazy(() => import("pages/role/role-detail"));
const RoleCreate = lazy(() => import("pages/role/role-create"));
const RoleEdit = lazy(() => import("pages/role/role-edit"));
const RoleList = lazy(() => import("pages/role/role-list"));
const Logout = lazy(() => import("pages/user/user-logout"));
const VisitCreate = lazy(() => import("pages/visit/visit-create"));
const VisitCreateMulti = lazy(() => import("pages/visit/visit-create-multi"));
const VisitEdit = lazy(() => import("pages/visit/visit-edit"));
const VisitDetail = lazy(() => import("pages/visit/visit-detail"));
const VisitList = lazy(() => import("pages/visit/visit-list"));
const RouteList = lazy(() => import("pages/route/route-list"));
const RouteEdit = lazy(() => import("pages/route/route-edit"));
const RouteCreate = lazy(() => import("pages/route/route-create"));
const StoreDocumentList = lazy(() => import("pages/store/store-document-list"));
const StoreDocumentCreate = lazy(
  () => import("pages/store/store-document-create"),
);
const StoreDocumentEdit = lazy(() => import("pages/store/store-document-edit"));
const StoreDocumentDetail = lazy(
  () => import("pages/store/store-document-detail"),
);
const NotFound = lazy(() => import("shared/pages/NotFound"));
const Dev = lazy(() => import("shared/pages/Dev"));

export const Routing = () => {
  const { user } = useUser();
  const ability = user.ability;
  return (
    <Routes>
      <Route path="/" element={<Auth />} />
      <Route
        path="/dev"
        element={
          <Dev place="" onUpdate={(place: string) => console.log(place)} />
        }
      />
      <Route
        path={SubjectParams.Object.url + "/tasks/"}
        element={
          <ProtectedRoute access={ability?.can("read", "Task")}> 
            <AddressTasksPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Object.url + "/task/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Task")}> 
            <AddressTaskItemsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Payment.url + "/tasks/"}
        element={
          <ProtectedRoute access={ability?.can("read", "Task")}> 
            <PaymentsTasksPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Payment.url + "/task/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Task")}> 
            <PaymentsTaskItemsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Machine.url + "/tasks/"}
        element={
          <ProtectedRoute access={ability?.can("read", "Task")}> 
            <MachineTasksPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Machine.url + "/task/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Task")}> 
            <MachineTaskItemsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Car.url + "/tasks/"}
        element={
          <ProtectedRoute access={ability?.can("read", "Task")}> 
            <CarTasksPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Car.url + "/task/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Task")}> 
            <CarTaskItemsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Address.url}
        element={
          <ProtectedRoute access={ability?.can("read", "Object")}>
            <AddressList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Address.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Object")}>
            <AddressDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Address.url + "/:id/stop-list"}
        element={
          <ProtectedRoute access={ability?.can("stop-list", "Object")}>
            <AddressStopList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Address.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Object")}>
            <AddressEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Address.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Object")}>
            <AddressCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Category.url}
        element={
          <ProtectedRoute access={ability?.can("read", "Category")}>
            <CategoryList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Category.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Category")}>
            <CategoryDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Category.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Category")}>
            <CategoryEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Category.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Category")}>
            <CategoryCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Category.url + "/:id/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Product")}>
            <ProductCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Category.url + "/:id/create-set"}
        element={
          <ProtectedRoute access={ability?.can("create", "Product")}>
            <ProductSetCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Country.url}
        element={
          <ProtectedRoute access={ability?.can("read", "Country")}>
            <CountryList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Country.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Country")}>
            <CountryDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Country.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Country")}>
            <CountryEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Country.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Country")}>
            <CountryCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.City.url}
        element={
          <ProtectedRoute access={ability?.can("read", "City")}>
            <CityList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.City.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "City")}>
            <CityEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.City.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "City")}>
            <CityCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Product.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Product")}>
            <ProductDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Product.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Product")}>
            <ProductEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Provider.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Provider")}>
            <ProviderList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Provider.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Provider")}>
            <ProviderDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Provider.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Provider")}>
            <ProviderEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Provider.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Provider")}>
            <ProviderCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Car.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Car")}>
            <CarList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Car.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Car")}>
            <CarDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Car.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Car")}>
            <CarEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Car.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Car")}>
            <CarCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Event.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Event")}>
            <EventList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Event.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Event")}>
            <EventDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Event.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Event")}>
            <EventEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Event.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Event")}>
            <EventCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={"/location-event/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Location")}>
            <LocationEventEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={"/location-event/create"}
        element={
          <ProtectedRoute access={ability?.can("update", "Location")}>
            <LocationEventCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Template.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Template")}>
            <TemplateList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Template.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Template")}>
            <TemplateDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Template.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Template")}>
            <TemplateEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Template.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Template")}>
            <TemplateCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Template.url + "/place"}
        element={
          <ProtectedRoute access={ability?.can("create-place", "Template")}>
            <TemplateCreatePlace />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Location.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Location")}>
            <LocationList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Location.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Location")}>
            <LocationDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Location.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Location")}>
            <LocationEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Location.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Location")}>
            <LocationCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Space.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Space")}>
            <SpaceList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Space.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Space")}>
            <SpaceEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Space.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Space")}>
            <SpaceCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Machine.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Machine")}>
            <MachineList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Machine.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Machine")}>
            <MachineDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Machine.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Machine")}>
            <MachineEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Machine.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Machine")}>
            <MachineCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Payment.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Payment")}>
            <PaymentList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Payment.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Payment")}>
            <PaymentDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Payment.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Payment")}>
            <PaymentEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Payment.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Payment")}>
            <PaymentCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Service.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Service")}>
            <ServiceList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Service.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Service")}>
            <ServiceDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Service.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Service")}>
            <ServiceEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Service.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Service")}>
            <ServiceCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Service.url + "/create-multi"}
        element={
          <ProtectedRoute access={ability?.can("create", "Service")}>
            <ServiceCreateMulti />
          </ProtectedRoute>
        }
      />

      <Route
        path={SubjectParams.Calibration.url + "/:machineId"}
        element={
          <ProtectedRoute access={ability?.can("read", "Calibration")}>
            <CalibrationListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Calibration.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Calibration")}>
            <CalibrationEdit />
          </ProtectedRoute>
        }
      />

      <Route
        path={SubjectParams.Order.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Order")}>
            <OrderList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Order.url + "/summary"}
        element={
          <ProtectedRoute access={ability?.can("read", "Order")}>
            <OrderSummary />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Order.url + "/:id"}
        element={
          <ProtectedRoute
            access={
              ability?.can("read", "Order") || ability?.can("update", "Order")
            }
          >
            <OrderDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Order.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Order")}>
            <OrderEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Order.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Order")}>
            <OrderCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.SnackAddress.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "SnackAddress")}>
            <SnackAddressList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.SnackAddress.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "SnackAddress")}>
            <SnackAddressDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.SnackAddress.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "SnackAddress")}>
            <SnackAddressEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.SnackAddress.url + "/upload/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "SnackAddress")}>
            <SnackAddressFile />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.SnackAddress.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "SnackAddress")}>
            <SnackAddressCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.SnackItem.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "SnackItem")}>
            <SnackItemList addressId={0} />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.SnackItem.url + "/:addressId/:productId"}
        element={
          <ProtectedRoute access={ability?.can("read", "SnackItem")}>
            <SnackItemDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.SnackItem.url + "/:addressId/edit/:productId"}
        element={
          <ProtectedRoute access={ability?.can("update", "SnackItem")}>
            <SnackItemEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.SnackItem.url + "/:addressId/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "SnackItem")}>
            <SnackItemCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Visit.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Visit")}>
            <VisitList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Visit.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Visit")}>
            <VisitEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Visit.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Visit")}>
            <VisitDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Visit.url + "/:id/open-orders"}
        element={
          <ProtectedRoute access={ability?.can("read", "Visit")}>
            <OpenOrdersList />
          </ProtectedRoute>
        }
      />

      <Route
        path={SubjectParams.Visit.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Visit")}>
            <VisitCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Visit.url + "/create-multi"}
        element={
          <ProtectedRoute access={ability?.can("create", "Visit")}>
            <VisitCreateMulti />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Route.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Route")}>
            <RouteList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Route.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Route")}>
            <RouteCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Route.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Route")}>
            <RouteEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Role.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Role")}>
            <RoleList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Role.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Role")}>
            <RoleDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Role.url + "/:id/permission"}
        element={
          <ProtectedRoute access={ability?.can("update", "Permission")}>
            <PermissionRoleForm />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Role.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Role")}>
            <RoleEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Role.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Role")}>
            <RoleCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.User.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "User")}>
            <UserList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.User.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "User")}>
            <UserCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.User.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "User")}>
            <UserEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.User.url + "/:id/permission"}
        element={
          <ProtectedRoute access={ability?.can("update", "Permission")}>
            <PermissionUserForm />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Investor.url + "/"}
        element={
          <ProtectedRoute access={ability?.can("update", "Investor")}>
            <InvestorList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Investor.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Investor")}>
            <InvestorDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Investor.url + "/:id/payout"}
        element={
          <ProtectedRoute access={ability?.can("read", "Investor")}>
            <PayoutInvestorList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Investor.url + "/:id/payout/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Payout")}>
            <PayoutInvestorCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Payout.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Payout")}>
            <PayoutInvestorList full={true} />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Payout.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Payout")}>
            <PayoutInvestorEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <InvestObjectList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "InvestObject")}>
            <InvestObjectCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "InvestObject")}>
            <InvestObjectEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <InvestObjectDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/:id/expenses"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <LocationExpensesDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/:id/expenses/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "InvestObject")}>
            <LocationExpensesCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/:id/expenses/edit/:eid"}
        element={
          <ProtectedRoute access={ability?.can("update", "InvestObject")}>
            <LocationExpensesEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/:id/expenses/items"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <LocationExpensesItemsList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/:id/expenses/items/:item"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <LocationExpensesItemsDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/:id/expenses/other"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <LocationExpensesOtherList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestObject.url + "/:id/expenses/other/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "InvestObject")}>
            <LocationExpensesOtherCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestGroup.url + "/"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <InvestGroupList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestGroup.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "InvestObject")}>
            <InvestGroupCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestGroup.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "InvestObject")}>
            <InvestGroupEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestGroup.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <InvestGroupDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestGroup.url + "/:id/payout"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <PayoutGroupCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestGroup.url + "/:id/payout/:pid"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <PayoutGroupEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestGroup.url + "/:id/expenses"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <GroupExpensesDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestGroup.url + "/:id/expenses/other"}
        element={
          <ProtectedRoute access={ability?.can("read", "InvestObject")}>
            <GroupExpensesOtherList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.InvestGroup.url + "/:id/expenses/other/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "InvestObject")}>
            <GroupExpensesOtherCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Store.url + ""}
        element={
          <ProtectedRoute access={ability?.can("read", "Store")}>
            <StoreDocumentList />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Store.url + "/create"}
        element={
          <ProtectedRoute access={ability?.can("create", "Store")}>
            <StoreDocumentCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Store.url + "/edit/:id"}
        element={
          <ProtectedRoute access={ability?.can("update", "Store")}>
            <StoreDocumentEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={SubjectParams.Store.url + "/:id"}
        element={
          <ProtectedRoute access={ability?.can("read", "Store")}>
            <StoreDocumentDetail />
          </ProtectedRoute>
        }
      />
      <Route path="/auth" element={<Auth />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
